import {
  CREATE_CARE_AND_USE_REQUEST,
  CREATE_CARE_AND_USE_SUCCESS,
  CREATE_CARE_AND_USE_FAILURE,
  GET_ALL_CARE_AND_USE_REQUEST,
  GET_ALL_CARE_AND_USE_SUCCESS,
  GET_ALL_CARE_AND_USE_FAILURE,
  GET_ONE_CARE_AND_USE_REQUEST,
  GET_ONE_CARE_AND_USE_SUCCESS,
  GET_ONE_CARE_AND_USE_FAILURE,
  EDIT_CARE_AND_USE_REQUEST,
  EDIT_CARE_AND_USE_SUCCESS,
  EDIT_CARE_AND_USE_FAILURE,
  DELETE_CARE_AND_USE_REQUEST,
  DELETE_CARE_AND_USE_SUCCESS,
  DELETE_CARE_AND_USE_FAILURE,
} from "./CareInstructionsTypes";

// --- GET ALL REDUCER ---
const getAllInitialState = {
  loading: false,
  careAndUseList: [],
  error: "",
};

const getAllCareAndUseReducer = (state = getAllInitialState, action) => {
  switch (action.type) {
    case GET_ALL_CARE_AND_USE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_CARE_AND_USE_SUCCESS:
      return {
        loading: false,
        careAndUseList: action.payload,
        error: "",
      };
    case GET_ALL_CARE_AND_USE_FAILURE:
      return {
        loading: false,
        careAndUseList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- GET ONE REDUCER ---
const getOneInitialState = {
  loading: false,
  careAndUseDetail: {},
  error: "",
};

const getOneCareAndUseReducer = (state = getOneInitialState, action) => {
  switch (action.type) {
    case GET_ONE_CARE_AND_USE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ONE_CARE_AND_USE_SUCCESS:
      return {
        loading: false,
        careAndUseDetail: action.payload,
        error: "",
      };
    case GET_ONE_CARE_AND_USE_FAILURE:
      return {
        loading: false,
        careAndUseDetail: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- CREATE REDUCER ---
const createInitialState = {
  loading: false,
  careAndUseData: {},
  error: "",
};

const createCareAndUseReducer = (state = createInitialState, action) => {
  switch (action.type) {
    case CREATE_CARE_AND_USE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CARE_AND_USE_SUCCESS:
      return {
        loading: false,
        careAndUseData: action.payload,
        error: "",
      };
    case CREATE_CARE_AND_USE_FAILURE:
      return {
        loading: false,
        careAndUseData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- EDIT REDUCER ---
const editInitialState = {
  loading: false,
  careAndUseData: {},
  error: "",
};

const editCareAndUseReducer = (state = editInitialState, action) => {
  switch (action.type) {
    case EDIT_CARE_AND_USE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_CARE_AND_USE_SUCCESS:
      return {
        loading: false,
        careAndUseData: action.payload,
        error: "",
      };
    case EDIT_CARE_AND_USE_FAILURE:
      return {
        loading: false,
        careAndUseData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- DELETE REDUCER ---
const deleteInitialState = {
  loading: false,
  successData: {},
  error: "",
};

const deleteCareAndUseReducer = (state = deleteInitialState, action) => {
  switch (action.type) {
    case DELETE_CARE_AND_USE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CARE_AND_USE_SUCCESS:
      return {
        loading: false,
        successData: action.payload,
        error: "",
      };
    case DELETE_CARE_AND_USE_FAILURE:
      return {
        loading: false,
        successData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getAllCareAndUseReducer,
  getOneCareAndUseReducer,
  createCareAndUseReducer,
  editCareAndUseReducer,
  deleteCareAndUseReducer,
};